import React, { useState } from 'react';
import { Poppins, Settings } from 'src/common';
import CommonMenu from 'src/components/CommonMenu';
import PdfInsights from 'src/components/pdf/PdfInsights';
import { AssessmentSelect } from 'src/components/select/AssessmentSelect';
import { DashboardQuery } from 'src/graphql/_generated';
import styled from 'styled-components';
import { ControlChartCapture } from 'src/components/charts/ControlChart';
import { ActivityData } from 'src/api/types/dashboard';
import { splitEventsByDateRange } from 'src/pages/DashboardPage/util';
import _ from 'lodash';

const Div = styled.div``;

interface HeadProps {
  isEmpty: boolean;
  selectedAssessment: string;
  setSelectedAssessmentStored: (assessmentId: string) => void;
  data?: DashboardQuery;
  activityData: ActivityData[];
}

export const Head: React.FC<HeadProps> = ({
  isEmpty,
  selectedAssessment,
  setSelectedAssessmentStored,
  data,
  activityData,
}) => {
  const [anchorEl, setAnchorEl] = useState<React.MouseEvent['currentTarget'] | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [chartImage, setChartImage] = useState<string | null>(null);

  const { overdue, range1, range2, range3 } = splitEventsByDateRange(activityData);
  const events = _.take([...overdue, ...range1, ...range2, ...range3], 4);

  const handleImageCaptured = (imageData: string) => {
    setChartImage(imageData);
  };

  const handlePdfClick = async (e: React.MouseEvent<HTMLLIElement>) => {
    e.stopPropagation();
    handleClose();
    setIsOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!data) return null;

  return (
    <>
      {isOpen && <PdfInsights data={data} chartImage={chartImage} onClose={() => setIsOpen(false)} events={events} />}
      <CommonMenu onPdfClick={handlePdfClick} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} />
      <ControlChartCapture
        value={data?.dashboard.controlImplementation}
        onImageCaptured={handleImageCaptured}
        width={86}
        height={86}
      />
      <Div className="panel">
        <Poppins px={32} weight={600}>
          Insights
        </Poppins>
        {!isEmpty && (
          <div className="panel">
            <AssessmentSelect value={selectedAssessment} onChange={(opt) => setSelectedAssessmentStored(opt.value)} />
            <Settings
              active={!!anchorEl}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
              }}
              variant="button"
              data-cy="common-menu"
            />
          </div>
        )}
      </Div>
    </>
  );
};
